import { VBtn } from 'vuetify/lib/components/VBtn';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "doctor-card-appointment d-flex flex-column ga-3" },
    [
      _vm.showAppointmentBlock
        ? [
            _vm.isExpressClosed
              ? _c(_setup.LpuNotWorkingLabel, {
                  attrs: { "lpu-working-text": _vm.lpuNotWorkingText },
                })
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "doctor-card-appointment__schedule",
                style: {
                  minHeight: `${_setup.SCHEDULE_CALENDAR_MIN_HEIGHT_PX}px`,
                },
              },
              [
                _vm.showCalendar
                  ? _c(_setup.DoctorCardCalendar, {
                      attrs: {
                        "day-items": _vm.dayItems,
                        "active-date": _vm.activeDate,
                        "active-day-slots": _vm.activeDaySlots,
                        "is-disabled":
                          _vm.isExpressAppointment &&
                          _vm.placeType !== "telemed",
                      },
                      on: {
                        "select-day": function ($event) {
                          return _setup.emit("select-day", $event)
                        },
                        slot: function ($event) {
                          return _setup.emit("slot", $event)
                        },
                      },
                    })
                  : _vm.isCardSlotsLoading
                  ? _c(_setup.ScheduleCalendarSkeleton)
                  : _vm.showAppointmentStub
                  ? _c(_setup.DoctorAppointmentStub)
                  : _vm._e(),
              ],
              1
            ),
            _vm._v(" "),
            _vm.placeType === "home"
              ? [
                  _vm.showHomeCallButton
                    ? _c(
                        VBtn,
                        {
                          staticClass:
                            "branding-btn branding-btn--primary rounded-20 text-none text-subtitle-1",
                          attrs: {
                            depressed: "",
                            color: "primary",
                            height: "52",
                            href: `tel:${_vm.lpuPhoneHref}`,
                            block: _setup.isMobile,
                            "data-qa": "lpu_doctors_list_home_call",
                          },
                        },
                        [
                          _c("span", {
                            staticClass: "ui-icon-car-clinic mr-2",
                          }),
                          _vm._v(
                            "\n        " +
                              _vm._s(_vm.homeCallLabel) +
                              "\n      "
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _setup.isMobile
                    ? _c(
                        "div",
                        { staticClass: "text-body-2 text-secondary--text" },
                        [
                          _vm._v(
                            "\n        " +
                              _vm._s(
                                _setup.tStatic(
                                  "Стоимость выезда врача к вам домой определяется удаленностью от клиники"
                                )
                              ) +
                              ".\n        " +
                              _vm._s(
                                _setup.tStatic(
                                  "Уточняйте цену у администратора клиники"
                                )
                              ) +
                              ".\n      "
                          ),
                        ]
                      )
                    : _vm._e(),
                ]
              : _vm._e(),
            _vm._v(" "),
            _vm.showClinicCallButton
              ? _c(
                  VBtn,
                  {
                    staticClass:
                      "branding-btn branding-btn--primary rounded-20 text-none text-subtitle-1",
                    attrs: {
                      depressed: "",
                      color: "primary",
                      height: "52",
                      href: `tel:${_vm.lpuPhoneHref}`,
                      block: _setup.isMobile,
                      "data-qa": "appointment-button-lpu-call",
                      "data-google-goal": "appointment_button_lpu_call",
                    },
                  },
                  [
                    _c("span", {
                      staticClass: "ui-icon-phone-none bg-gray-0--text mr-2",
                    }),
                    _vm._v(
                      "\n      " +
                        _vm._s(_setup.tStatic("Позвонить в клинику")) +
                        "\n    "
                    ),
                  ]
                )
              : _vm._e(),
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.isStaff &&
      !_setup.isMobile &&
      (_vm.doctor.last_relevance ||
        (_vm.showAppointmentBlock && _vm.staffAppointmentType))
        ? _c("div", { staticClass: "d-flex flex-column ga-1" }, [
            _vm.doctor.last_relevance
              ? _c("div", { staticClass: "staff-appointment-type ma-0" }, [
                  _c("div", { staticClass: "staff-appointment-type__text" }, [
                    _vm._v(
                      "\n        " +
                        _vm._s(_setup.tStatic("Актуально")) +
                        " " +
                        _vm._s(_vm.doctor.last_relevance) +
                        "\n      "
                    ),
                  ]),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.showAppointmentBlock && _vm.staffAppointmentType
              ? _c("div", { staticClass: "staff-appointment-type ma-0" }, [
                  _c("div", { staticClass: "staff-appointment-type__text" }, [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.staffAppointmentType) +
                        "\n      "
                    ),
                  ]),
                ])
              : _vm._e(),
          ])
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }